/**
Copyright (c) 2023, 2024, 2025 Amica Corp.
All rights reserved.

This source code, resulting binary forms, and associated documentation
(the "Software") may only be used, modified, or distributed, with or
without modification, under the terms of a written license agreement
with Amica Corp. (the "License"). All rights to manufacture, use,
redistribute, or sell anything described herein, in whole or in part,
are granted only as explicitly permitted by such License. The receipt
or possession of the Software does not convey any of these rights.

This Software is provided "AS IS," WITHOUT WARRANTY OF ANY KIND, express
or implied, including but not limited to the implied warranties of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.

For additional terms, see https://amica.cloud/software-copyright/
 */

import { differenceInSeconds } from 'date-fns';

// Function to store visual mapper data in localStorage
export const storeVisualMapper = () => {
  // update the localStorage timestamp value to calculate the time taken once the visual is rendered
  localStorage.setItem('visualTimeDifference', JSON.stringify(new Date().toISOString()));
};
/**
 * Calculates the difference in seconds between the current time and a stored visual start time in `localStorage`.
 *
 * @param {Date} currentData - The current timestamp, expected to be a `new Date()` object representing the current time.
 * @param {string} [storageKey='visualTimeDifference'] - Optional. The key under which the start time is stored in `localStorage`. Defaults to `'visualTimeDifference'`.
 * @returns {string} A string representing the time difference in seconds (e.g., "5 seconds").
 *
 * @throws {Error} If the stored value is not a valid date or cannot be parsed.
 */
export const retrieveVisualLoadDuration = (currentData, storageKey = 'visualTimeDifference') => {
  if (!currentData) {
    currentData = new Date();
  }

  const visualStartTime = JSON.parse(localStorage.getItem(storageKey));
  const timeDifferenceInMsec = differenceInSeconds(currentData, new Date(visualStartTime));

  return `${timeDifferenceInMsec} seconds`;
};
